// Global Imports
import React from "react";

// Local Imports
import SportEventCalendarApp from "../calendar/index";

// types, enums and interface
type TabsAU = "Racing" | "Sports";
type TabsUK = "Racing" | "Sports";

// Constants
const tabsAU: string[] = ["Racing", "Sports"];
const tabsUK: string[] = ["Racing", "Sports"];
interface IProps {
  selectedCountry: string;
  isDesktopResolution: boolean;
}

// Render Main Componnet
const CalendarApp: React.FC<IProps> = ({
  selectedCountry,
  isDesktopResolution,
}) => {
  const [selectedTab, setSelectedTab] = React.useState<TabsAU | TabsUK>(
    "Sports"
  );

  // render pages
  const renderPage = (tab: TabsAU | TabsUK) => {
    switch (tab) {
      case "Racing":
        return <div className="py-4"></div>;

      case "Sports":
        return (
          <div className="py-4">
            <SportEventCalendarApp
              selectedCountry={selectedCountry}
              isDesktopResolution={isDesktopResolution}
            />
          </div>
        );

      default:
        <p>Sports Calendar</p>;
        break;
    }
  };

  return (
    <React.Fragment>
      <div className="md:flex w-full">
        <div className="container p-0 w-full">
          <div className="promotion-sub bg-transparent">
            <nav className="overflow-x-auto flex flex-nowrap w-full">
              {selectedCountry === "AU" ? (
                <React.Fragment>
                  {tabsAU.map((tab: any, index: React.Key) => (
                    <div
                      key={index}
                      onClick={() => setSelectedTab(tab)}
                      className={`text-center cursor-pointer text-gray-600 py-4 px-6 block border-b-2 hover:text-blue-500 focus:outline-none w-full 
                      ${
                        tab === "Racing" && "disabled-div pointer-events-none"
                      } ${selectedTab === tab && "active"} `}
                    >
                      {tab}
                    </div>
                  ))}{" "}
                </React.Fragment>
              ) : (
                <React.Fragment>
                  {tabsUK.map((tab: any, index: React.Key) => (
                    <div
                      key={index}
                      onClick={() => setSelectedTab(tab)}
                      className={`text-center cursor-pointer text-gray-600 py-4 px-6 block hover:text-blue-500 focus:outline-none w-full ${
                        selectedTab === tab && "active"
                      } `}
                    >
                      {tab}
                    </div>
                  ))}{" "}
                </React.Fragment>
              )}
            </nav>
          </div>
          <div className="w-full h-full mt-1">{renderPage(selectedTab)}</div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CalendarApp;
